// v400.66: live Total Sale Amount + Distributor Payout in sale flows.
// Pure derivation from qty/unit price/wholesale — updates on every keystroke.
import { useTranslation } from "react-i18next";

export function SaleSummary({ qty, unitPrice, wholesale }) {
  const { t } = useTranslation();
  const n = Math.max(1, Number(qty) || 1);
  const price = Number(unitPrice);
  if (!Number.isFinite(price) || price <= 0) return null;
  const total = n * price;
  const ws = wholesale != null ? Number(wholesale) : null;
  const payout = ws != null && Number.isFinite(ws) ? total - n * ws : null;
  return (
    <div
      className="rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2 flex flex-col gap-1"
      data-testid="sale-summary"
    >
      <div className="flex items-baseline justify-between text-sm">
        <span className="text-zinc-500 font-medium">{t("sale_summary.total")}</span>
        <span className="font-semibold text-zinc-900 tabular-nums" data-testid="sale-total-line">
          ${total.toFixed(2)}
        </span>
      </div>
      {payout != null && (
        <div className="flex items-baseline justify-between text-sm">
          <span className="text-zinc-500 font-medium">{t("sale_summary.payout")}</span>
          <span
            className={`font-semibold tabular-nums ${payout < 0 ? "text-red-600" : "text-[#8a6a1c]"}`}
            data-testid="sale-payout-line"
          >
            ${payout.toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
}
